import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, type Auth } from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  type Firestore,
} from 'firebase/firestore';
import { getStorage, type FirebaseStorage } from 'firebase/storage';
import { env } from './env';

export const firebaseApp: FirebaseApp = initializeApp(env.firebase);
export const auth: Auth = getAuth(firebaseApp);

/** Disk-backed cache: faster reloads and offline-friendly reads (tabs sync via tab manager). */
export const db: Firestore = initializeFirestore(firebaseApp, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});
export const storage: FirebaseStorage = getStorage(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
